import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';

import {EvaluationItemProps} from '../types';
import {buildCallRoute} from '../utils';
import {CallItemMetrics} from './CallItemMetrics';

export const EvaluationItem: React.FC<EvaluationItemProps> = ({
  name,
  callId,
  displayName,
  calledAt,
  latency,
  tokens,
  cost,
  userId,
  entityName,
  projectName,
}) => {
  const route = useMemo(
    () => buildCallRoute(callId, 'evaluations', entityName, projectName),
    [callId, entityName, projectName]
  );

  return (
    <Tailwind>
      <Link
        to={route}
        className="flex min-h-[52px] items-center gap-12 px-20 py-12 hover:bg-moon-50">
        {/* Left: Icon + Name (flexible) */}
        <div className="flex min-w-0 flex-1 items-center gap-12">
          <Icon
            name="benchmark-square"
            className="flex-shrink-0 text-teal-500"
            width={16}
            height={16}
          />
          <div className="min-w-0 flex-1">
            <div className="truncate font-medium text-moon-900">
              {displayName || name}
            </div>
          </div>
        </div>

        {/* Right: Metrics columns */}
        <CallItemMetrics
          cost={cost}
          tokens={tokens}
          latency={latency}
          timestamp={calledAt}
          userId={userId}
        />
      </Link>
    </Tailwind>
  );
};
